<template>
  <div :class="{ isNotQrcodeMode: !isQrcodeMode }" class="imgBox">
    <div class="item">
      <van-image class="imgPic" fit="cover" :src="goodsPic" />
      <div v-if="isQrcodeMode" class="label">商品图片</div>
    </div>
    <div v-if="isQrcodeMode" class="item" @click="showQrcodePopup">
      <van-image class="imgPic" fit="cover" :src="SearchKey" />
      <div class="label">商品二维码</div>
      <div class="tip">(点击查看并保存)</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'SouhuoH5Qrcodepart',

  props: {
    goodsPic: {
      type: String,
      default: ''
    },
    SearchKey: {
      type: String,
      default: ''
    },
    isQrcodeMode: {
      type: Boolean,
      default: false
    },
    PlatformType: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {}
  },

  mounted() {},

  methods: {
    ...mapMutations(['SET_QRCODE_POPUP']),
    showQrcodePopup() {
      this.SET_QRCODE_POPUP({
        isShow: true,
        qrCodeSrc: this.SearchKey,
        platformType: this.PlatformType
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.imgBox {
  display: flex;
  justify-content: space-between;
  margin-top: vw(30);
  &.isNotQrcodeMode {
    justify-content: space-around;
  }
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .imgPic {
      display: block;
      width: vw(164);
      height: vw(164);
    }
    .label {
      color: #999999;
      margin: 4px 0;
    }
    .tip {
      color: #ef204c;
    }
  }
}
</style>
